export const IndexRoutes = [
  {
    path: '/',
    alias: ['/:preview?'],
    name: 'Index',
    component:  () => {
      return import('@pages/standard-list/index.vue')
    },
    props: {
      category: 'premium',
      pageTitle: '精品自营车',
      shareTitle: '精品自营车｜爱车的诺诺',
    },
    meta: {
      title: '首页',
    },
  },
]
